/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { getDateInMMDDYYYYFormat } from "../../../../../../SharedModules/DateUtilities/DateUtilities";

function ConfirmationPopup({ setShowConfirmationPopup }) {
  const checkLogData = useSelector(
    (state) => state.sharedState.RemoveSuspendedDtReducer?.checkLogData
  );

  return (
    <div className="panel tBillPanel-space devider-line pb-0">
      <div className="row">
        <div className="form-wrapper">
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Info"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkInfo"
                value={checkLogData?.checkInfo}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Log Number"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkLogNumber"
                value={checkLogData?.checkLogNum}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-wrapper">
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Current Suspended Date"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="currentSuspendedDate"
                value={
                  checkLogData && checkLogData.suspendedDt
                    ? getDateInMMDDYYYYFormat(checkLogData.suspendedDt)
                    : ""
                }
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Batch Date"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="batchDate"
                value={
                  checkLogData && checkLogData.batchDt
                    ? getDateInMMDDYYYYFormat(checkLogData.batchDt)
                    : ""
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-wrapper">
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Batch Number"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="batchNumber"
                value={checkLogData?.batchNum}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Number"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkNumber"
                value={checkLogData?.checkNum}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-wrapper">
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Date"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkDate"
                value={
                  checkLogData && checkLogData.checkDt
                    ? getDateInMMDDYYYYFormat(checkLogData.checkDt)
                    : ""
                }
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Amount"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkAmount"
                value={checkLogData?.checkAmt}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="form-wrapper">
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Issuer"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkIssuer"
                value={checkLogData?.checkIssuer}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="mui-custom-form field-xl">
              <TextField
                label="Check Identifier"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                name="checkIdentifier"
                value={checkLogData?.checkIdentifier}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationPopup;
